import React, { FC } from 'react'

import { RadioBasedField } from '@new/__global/components/Filters/FiltersVariations/Radio'
import { FilterRenderingComponentProps } from '@new/__global/components/FiltersFramework'
import { colorModeOptions } from '@new/domains/fastBookingsTapeChart/config/colors'

type ColorByFilterProps = FilterRenderingComponentProps<string>

const options = colorModeOptions.map(option => ({
  title: option.label,
  id: option.value,
  value: option.value,
}))

export const ColorByFilter: FC<ColorByFilterProps> = props => {
  const { label, id } = props
  return (
    <RadioBasedField title={label || 'Color by'} radioGroupId={id} options={options} {...props} />
  )
}
